module.exports = __webpack_public_path__ + "static/img/site2.615f723.gif";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/site2.gif
// module id = w2mV
// module chunks = 1